export default {
    LANGUAGE_CHANGED: 'LANGUAGE_CHANGED',
    HIDE_TOOLTIP: 'HIDE_TOOLTIP',
    CREATIONS: 'CREATIONS',
    HISTORY: 'HISTORY',
    GENERATIONS: 'GENERATIONS',
    WARNING: 'warning',
    GET_CREDITS: 'get_credits',
    CANCEL: 'cancel',
    SUBMIT: 'submit',
    FACEBOOK: 'FACEBOOK',
    TWITTER: 'TWITTER',
    GRADIENT: 'gradient',
    TUMBLR: 'TUMBLR',
    COPY_LINK: 'COPY_LINK',
    REC_ID: 'rec_id',
    STYLE_VALUE: 'style',
    UPDATE_USER_CREDITS: 'UPDATE_USER_CREDITS',
    REFRESH_IMAGE: 'REFRESH_IMAGE',
    LOADING: 'LOADING',
    DEFAULT: 'DEFAULT',
    DETAIL: 'DETAIL',
    GENERATING: 'GENERATING',
    START: 'START',
    WAITING: 'WAITING',
    SUCCESS: 'SUCCESS',
    ERROR: 'ERROR',
    VIOLATION: 'VIOLATION', // 输入违规， 例如 色情，暴力，政治敏感等
    IMAGE_WITHOUT_PERSON: 'IMAGE_WITHOUT_PERSON', // 图片没有人物， 例如 色情，暴力，政治敏感等
    VIDEO_WITHOUT_PERSON: 'VIDEO_WITHOUT_PERSON', // 视频没有人物， 例如 色情，暴力，政治敏感等
    RUNNING: 'RUNNING',
    INVALID: 'INVALID', // 输入不合规, 模型识别，语言检测等
    CANCELLED: 'CANCELLED', // 任务被取消
    PARTIAL_SUCCESS: 'PARTIAL_SUCCESS', // 部分成功

    FACE: 'faces',
    ENTIRETY: 'general_scenes',
    SMALL: 'SMALL',
    SETTING: 'SETTING',
    EXPORTING: 'EXPORTING',
    UPLOADING: 'UPLOADING',
    PROGRESS: 'PROGRESS',
    INIT_PROJECT: 'INIT_PROJECT',
    TEXT_TO_IMAGE_MODAL: 'TEXT_TO_IMAGE_MODAL',
    TEXT_TO_IMAGE_RATIO: 'TEXT_TO_IMAGE_RATIO',
    TEXT_TO_IMAGE_GENERATE_NUMBER: 'TEXT_TO_IMAGE_GENERATE_NUMBER',
    TEXT_TO_IMAGE_STYLE: 'TEXT_TO_IMAGE_STYLE',
    TEXT_TO_IMAGE_AI_PROMPT: 'TEXT_TO_IMAGE_AI_PROMPT',
    CHANGE_START: 'changeStart',
    CHANGE: 'change',
    CHANGE_END: 'changeEnd',
    CLICK: 'click',

    LOCAL: 0,
    AI_VIDEO_S3: 1,
    AI_VIDEO_TEXT_IMAGE_S3: 2,
    AI_VIDEO_IMAGE_IMAGE_S3: 3,
    AI_VIDEO_FLEXCLIP: 4,
    BEFORE: 'BEFORE',
    COMPARE: 'COMPARE',
    AFTER: 'AFTER',
    ACCOUNT_CHANGE: 'ACCOUNT_CHANGE',
    USER_SPACE_CHANGE: 'USER_SPACE_CHANGE',

    ALL: 'ALL',
    VOCAL: 'VOCAL',
    INSTRUMENTAL: 'INSTRUMENTAL',
    TEXT_TO_MUSIC: 'TEXT_TO_MUSIC',
    MUSIC_TO_MUSIC: 'MUSIC_TO_MUSIC',
    SOUND_EFFECT: 'SOUND_EFFECT',
    PLAY: 'PLAY',
    PAUSE: 'PAUSE',

    NO_DEVICE_LIST: 'NO_DEVICE_LIST',
    NO_PERMISSION: 'NO_PERMISSION',
    RECORDING: 'RECORDING',

    AI_AUDIO_S3: 1,
    AI_AUDIO_FLEXCLIP: 2,

    RETRY: 'RETRY',
    SOURCE_LOADING_ERROR: 'SOURCE_LOADING_ERROR',

    AUDIO_TAG_TYPE_SFX: 'AUDIO_TAG_TYPE_SFX',
    AUDIO_TAG_TYPE_MUSIC: 'AUDIO_TAG_TYPE_MUSIC',
    AUDIO_TAG_TYPE_INST: 'AUDIO_TAG_TYPE_INST',

    AUDIO_GEN_SCENE_MUSIC: 'music',
    AUDIO_GEN_SCENE_ACCOMPANY: 'accompany',

    BUSY: 'BUSY',
    CLOSE: 'CLOSE',
    DISCOUNT: 'DISCOUNT',

    SMALL_MODAL: 'SMALL_MODAL',

    STEP_TYPE_HOME: 'STEP_TYPE_HOME',
    STEP_TYPE_SCRIPTS_PASTE: 'STEP_TYPE_SCRIPTS_PASTE',
    STEP_TYPE_SCRIPTS_EDIT: 'STEP_TYPE_SCRIPTS_EDIT',
    STEP_TYPE_VIDEO_SETTINGS: 'STEP_TYPE_VIDEO_SETTINGS',
    AI_GENERATED: 'AI_GENERATED',
    STOCK_LIBRARY: 'STOCK_LIBRARY',
    IMAGE_AND_VIDEO_MIXING: 'IMAGE_AND_VIDEO_MIXING',
    IMAGE: 'IMAGE',
    VIDEO: 'VIDEO',
    SORT_TYPE_RELEVANT: 'SORT_TYPE_RELEVANT',

    IDLE: 'IDLE',
    PLAYING: 'PLAYING',
    TWO_ROW: 'TWO_ROW',
    ONE_ROW: 'ONE_ROW',
    GRAY: 'GRAY',
    WHITE: 'WHITE',

    TEXT_TO_SPEECH: 'TEXT_TO_SPEECH',
    CLONE_VOICE: 'CLONE_VOICE',
    VOICE_LIST: 'VOICE_LIST',
    FAVORITE: 'FAVORITE',
    LINE: 'LINE',

    HISTORY_LIST: 'HISTORY_LIST',
    RECORD_IN_CREATE_CLONE: 'RECORD_IN_CREATE_CLONE',

    FLEX_CLIP: 'FLEX_CLIP',
    MICROSOFT: 'MICROSOFT',
    CLONE_BY_SELF: 'CLONE_BY_SELF',
    CLONE_BY_FLEX_CLIP: 'CLONE_BY_FLEX_CLIP',
    PARAGRAPH_PLAY: 'PARAGRAPH_PLAY',
    GLOBAL_PLAY: 'GLOBAL_PLAY',

    IMG2IMG_KLING16_PROMPT: 'IMG2IMG_KLING16_PROMPT',
    WAN_EFFECTS: 'WAN_EFFECTS',
    KLING16: 'KLING16',
    KLING16_EFFECT_STD: 'KLING16_EFFECT_STD',
    HOME: 'HOME',
    COMMUNITY: 'COMMUNITY',
    AI_TOOL_LIST: 'AI_TOOL_LIST',
    MY_SPACE: 'MY_SPACE',
    SHARED_CREATIONS: 'SHARED_CREATIONS',
    MY_CREATIONS: 'MY_CREATIONS',
    LIKED_CREATIONS: 'LIKED_CREATIONS',
    HOME_WORK: 'HOME_WORK',
    LIKE_WORK: 'LIKE_WORK',
    SHARED_WORK: 'SHARED_WORK',
    MY_CREATIONS_WORK: 'MY_CREATIONS_WORK',
    MY_CREATIONS_DETAIL_WORK: 'MY_CREATIONS_DETAIL_WORK',
    COMMUNITY_WORK: 'COMMUNITY_WORK',
    TEMPLATE_WORK: 'TEMPLATE_WORK',
    ADVERTISING_WORK: 'ADVERTISING_WORK',

    TOOL_PREVIEW: 'TOOL_PREVIEW',
    COMMUNITY_PREVIEW: 'COMMUNITY_PREVIEW',

    FOOTER: 'FOOTER',

    TEXT_TO_IMAGE: 'TEXT_TO_IMAGE',
    IMAGE_TO_IMAGE: 'IMAGE_TO_IMAGE',
    PHOTO_EDITOR: 'PHOTO_EDITOR',
};
